import { Component, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { UnsubscriberComponent } from 'src/app/components/shared/unsubscriber.component';
import { AppStorageEnum } from 'src/app/models/storage.enum';
import { PagesService } from 'src/app/services/application-resources/pages.service';
import { LanguagesService } from 'src/app/services/languages.service';
import { environment } from 'src/environments/environment';
import { fadeAnimation } from './animations/fade.animation';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    animations: [fadeAnimation],
    standalone: false
})
export class AppComponent extends UnsubscriberComponent implements OnInit {
  constructor(
    private router: Router,
    private languageService: LanguagesService,
    private pagesService: PagesService
  ) {
    super();
  }

  ngOnInit() {
    if (environment.favicon) {
      this.useFavicon(environment.favicon);
    }

    this.subscriptions.add(
      this.router.events.subscribe((val) => {
        if (val instanceof RoutesRecognized) {
          const paramLang = localStorage.getItem(AppStorageEnum.storeLanguage);
          const isCurrentLang =
            this.languageService.getCurrentLang() === paramLang;

          if (!isCurrentLang) {
            this.languageService.setCurrentLang(paramLang);
          }
        }
      })
    );

    this.pagesService.initializeDynamicLists();
    this.pagesService.initializeDynamicDashboards();
    this.pagesService.initializeDynamicForms();
  }

  // Points the document's icon link at the build's own svg (UAT "U", prod
  // "B"), so tabs for different environments are told apart at a glance.
  // index.html is shared by every build, so the swap is done here rather
  // than with a second index file.
  private useFavicon(href: string): void {
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;
    link.type = 'image/svg+xml';
    link.href = href;
  }
}
